// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZBPMkvjxXgHnUVIiJWNj {\n  font-weight: 600;\n  font-size: 22px;\n  margin-top: 10px;\n}\n\n.RM5D87oVKYv7r2EIsov2 {\n  margin-bottom: 20px;\n}\n\n.VDQ5fjAisZe9f697MRE_ {\n  background: #ffffff;\n  border: 1px solid #2755fe;\n  margin-right: 15px;\n  border-radius: 5px;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2755fe;\n}\n\n._tcIHHZL02hgkjS4IPPE {\n  width: 92px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reqModalTitle": "ZBPMkvjxXgHnUVIiJWNj",
	"firstRow": "RM5D87oVKYv7r2EIsov2",
	"cancelButton": "VDQ5fjAisZe9f697MRE_",
	"okBtn": "_tcIHHZL02hgkjS4IPPE"
};
export default ___CSS_LOADER_EXPORT___;
